/* eslint-disable react/react-in-jsx-scope */
import './App.css';
import { motion } from 'framer-motion';
import NavigationRoutes from './routes';
import {stage} from './config'
import { AwsRum } from 'aws-rum-web';
if (stage?.includes('prod')) {

    try {
        const config = {
            sessionSampleRate: 1,
            identityPoolId: "us-east-1:39fd5851-e0f7-41c3-890d-bd31d1ffde92",
            endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
            telemetries: ["performance","errors","http"],
            allowCookies: true,
            enableXRay: true
        };
      
        const APPLICATION_ID = 'ee531cb2-6049-40e8-9a8d-e720e005ac2b';
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'us-east-1';
      
        const awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}
function App(props) {
    const navigationPath = NavigationRoutes(props)
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ 
                duration: 0.5,
                delay: 0.5, 
            }}
        >
            {navigationPath}
        </motion.div>
    );
}

export default App;
